import { Fragment, useState, useEffect } from 'react';
import { Transition } from '@headlessui/react';
import { FaTimes } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import axios from '../../../services/api';
import { generateUUID } from '../../../services/utils';

export default function CategoryModal({ isOpen, onClose, category, callCenterId, onSuccess }) {
  const { t } = useTranslation();
  const [categoryName, setCategoryName] = useState('');

  useEffect(() => {
    if(isOpen) {
      setCategoryName(category?.name || '');
    }
  }, [isOpen, category]);

  const handleSave = async () => {
    // Validation
    if (!categoryName.trim()) {
      toast.error(t('Please input all required fields'));
      return;
    }

    try {
      if (category) {
        await axios.put(`/callcenter-categories/${category._id}`, { name: categoryName, centerId: callCenterId, categoryId: category?.categoryId || '' });
        toast.success(t('Update Successfully'));
      } else {
        await axios.post(`/callcenter-categories`, { name: categoryName, centerId: callCenterId, categoryId: generateUUID() });
        toast.success(t('Save Successfully'));
      }
      onSuccess();
      onClose();
    } catch (error) {
      // toast.error(t('Save Failed'));
      console.error('Error saving category:', error);
    }
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[70] app-text">
        <div className="bg-white w-[400px] rounded-lg shadow-xl flex flex-col">
          {/* Header */}
          <div className="bg-black text-white px-4 py-3 rounded-t-lg flex justify-between items-center">
            <h2 className="text-lg font-semibold">{t('Category')}</h2>
            <button
              onClick={onClose}
              className="text-white/70 hover:text-white transition-colors"
            >
              <FaTimes />
            </button>
          </div>

          {/* Content */}
          <div className="p-6">
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                {t('category_name')}<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={categoryName}
                onChange={(e) => setCategoryName(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                // placeholder={t('Enter category name')}
              />
            </div>

            {/* Action Buttons */}
            <div className="flex justify-end gap-3">
              <button
                onClick={onClose}
                className="px-6 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors"
              >
                {t('Cancel')}
              </button>
              <button
                onClick={handleSave}
                className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors"
              >
                {t('Save')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  );
}

